import AclRoutes from "./AclRoutes";
import AppRoutes from "./AppRoutes";
import MenuRoutes from "./MenuRoutes";

export const getRoute = (path) => {
    return AclRoutes.find(route => route.path === path);
}

export const isAllowed = (path, role) => {
    return getRoute(path).permissions.includes(role);
}

export const getAppRoutes = () => {
    return AppRoutes
}

export const getMenuRoutes = () => {
    return MenuRoutes
}

export const getAclRoutes = () => {
    return AclRoutes
}

